
import React, { useEffect, useState } from "react";
import axios from "axios";
import MemberList from "./MemberList";
import "../../stylesheets/home.css";
import Modal from "@material-ui/core/Modal";
import Grid from "@material-ui/core/Grid";
import { BrowserView, MobileView } from "react-device-detect";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import ReactGA from "react-ga";
import Dashboard from './dashboardnew/index.jsx';
import Sidebar from './dashboardnew/Sidebar.jsx';
import { Box } from '@mui/material';
require("dotenv").config();
const DOMAIN = process.env.REACT_APP_DOMAIN;

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 350,
    textAlign: "center",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    ["@media only screen and (max-width: 420px)"]: {
      width: 220,
      marginLeft: 0, 
    },
  },
}));

function Home({ isAuth }) {
  const [members, setMembers] = useState([]);
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const isAuthUser = isAuth;

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2 id="simple-modal-title">You are not Logged In</h2>
      <p className="simple-modal-desc" id="simple-modal-description">
        TO VIEW THIS PAGE, YOU NEED TO BE LOGGED IN TO THE SITE
      </p>
      <div className="buttons">
        <Link
          to="/login"
          onClick={handleClose}
          style={{ textDecoration: "none", color: "black" }}
        >
          <button className="btn btn-primary btn-lg">Login</button>
        </Link>
      </div>
    </div>
  );

  useEffect(() => {
    getAllMember();
  }, []);

  const getAllMember = () => {
    axios
      .get(`${DOMAIN}/api/dashboard`)
      .then((res) => {
        setMembers(res.data.result);
      })
      .catch((err) => {
      });
  };

  useEffect(() => {
    if (isAuthUser) {
      handleClose();
    } else {
      setTimeout(function () {
        handleOpen();
      }, 2000);
    }
  });

  return (
  <div>
    <MobileView>
      <Box sx={{ padding: '20px' }}>
        <Dashboard />
      </Box>
    </MobileView>

    {/* Browser View: The full 3D Sidebar + Dashboard Layout */}
    <BrowserView>
      <Box sx={{ display: 'flex' }}>
        {/* 1. The Sideboard (Fixed on left) */}
        <Sidebar />

        {/* 2. The Main Content Area (Scrollable on right) */}
        <Box 
          component="main" 
          sx={{ 
            flexGrow: 1, 
            marginLeft: '260px', 
            backgroundColor: '#fff',
            minHeight: '100vh'
          }}
        >
          <Dashboard />
        </Box>
      </Box>
    </BrowserView>
  </div>
);
}

export default Home;
